import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import { logger } from '../../utils/logger';
import './ConsoleNavMenu.css';
import * as signalR from "@microsoft/signalr";
import BatteryBox from './navMenu/BatteryBox';
import MsgBox from './navMenu/MsgBox';
import ModeBox from './navMenu/ModeBox';
import {useTranslation} from "react-i18next";
import { NavDropdown, Dropdown } from 'react-bootstrap';
import UserSettings from './navMenu/UserSettings';


function ConsoleNavMenu({drone = null, toggleShowMenu = null, showMsgsAct = null, startMsgs = null}){
    //const { t } = useTranslation(['account']);//todo: ломает карту?
    const protocol = new signalR.JsonHubProtocol();
    const hubRef = useRef(null);
    const [login, setLogin] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [missionPlannerUrl, setMissionPlannerUrl] = useState("");
    const [imei, setImei] = useState(drone?.imei ?? null);
    const [arm, setArm] = useState(drone?.isArm);
    const [uavMode, setUavMode] = useState(drone?.mode);
    const [uavType, setUavType] = useState(drone?.mavType);
    const [hbUpdate, setHbUpdate] = useState(null);
    const [mName, setMName] = useState(drone?.name);
    const [isOnline, setIsOnline] = useState(drone?.isOnline ?? false);
    
    const [batteryRemaining, setBatteryRemaining] = useState(drone?.batteryRemaining);

    const [updateTelemFromHub, setUpdateTelemFromHub] = useState(null);
    const [telemetry, setTelemetry] = useState([]);
    const [currentTelemetry, setCurrentTelemetry] = useState({imei: 0, batteryRemaining: null, height: 0, speed: 0, sputniksCount: 0});

    const [isAstra, setIsAstra] = useState(false);

    useEffect(() => {
        axios.get('api/user/start')
            .then(response => {
            setLogin(response.data.login);
            setIsAdmin(response.data.isAdmin);
            setMissionPlannerUrl(response.data.missionPlannerUrl);
            logger.info(response);
            })
            .catch((error) => {logger.info(error.response)});
    }, [window.location.href]);

    useEffect(() => {
        logger.debug("ConsoleNavMenu mount");
        logger.debug(process.env.REACT_APP_SERVICE);
        setIsAstra(process.env.REACT_APP_SERVICE == 'astra');

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;

        

        connection.on('HbStatus', (message) =>
        {
            //logger.debug("hb navMenu");
            setHbUpdate(message);
        });

        connection.on('Telemetry', (message) => {
            setUpdateTelemFromHub(message);
        });

        connection.start();
        hubRef.current = connection;

        return () => {
            connection.stop();
            logger.debug("ConsoleNavMenu unmount!");
        };
      }, []);

    useEffect(() => {
        if(hbUpdate != null){
            if(hbUpdate.imei === drone?.imei) {
                setArm(hbUpdate.isArm);
                setUavMode(hbUpdate.mode);
                setUavType(hbUpdate.type);
            }
        } 
    }, [hbUpdate]);

    useEffect(() => {
        //logger.debug("update drone dd");
        if(drone != null) {
            setArm(drone.isArm);
            setUavMode(drone.mode);
            setImei(drone.imei);
            setBatteryRemaining(drone?.batteryRemaining);
            setUavType(drone?.mavType);
        }
        //logger.debug(drone);
        setIsOnline(drone?.isOnline ?? false);
        setMName(drone?.name);
        switchTelemetry();
        //todo: request api
    }, [drone]);

    useEffect(() => {
        setTelem(updateTelemFromHub);
    }, [updateTelemFromHub]);

    useEffect(() => {
        logger.debug("toggleShowMenu rerend!");
    }, [showMsgsAct, toggleShowMenu]);

    function switchTelemetry() {
        if(drone === null) {
            return;
        }

        setCurrentTelemetry(telemetry.find((item) => item.imei === drone.imei));
    }

    function setTelem(msg) {
        setTelemetry((telems) => {
            const itemExists = telems.some((item) => item.imei === msg.imei);
            if(itemExists) {
                return telems.map((t) =>
                    t.imei === msg.imei
                      //? { ...t, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount }
                      ? { ...t, ...msg }
                      : t
                  )
            } else {
                //return [...telems, {imei: msg.imei, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount}];
                return [...telems, { ...msg }];
            }
        });

        if(msg?.imei === drone?.imei) {
            setCurrentTelemetry(msg);
        }
    }

    return(
        <header>
                <div className='console-nav-menu'>
                    { mName == null ? 
                    <div className='empty-grid'>
                        {isAstra ? <div onClick={() => {window.location = '/'}} className='tel-box logo-box'><img className='astra-icon' src="/image/astra/astra_logo.svg"/></div> : <div className='tel-box logo-box'>Air-link Console</div>}
                        <div className='tel-box menu-box'>
                            <div className='menu-box-sep'/>
                            <UserSettings login = {login} isAdmin = {isAdmin} missionPlannerUrl={missionPlannerUrl} isAstra = {isAstra}/>
                        </div>
                    </div>
                    :  
                    <div className='telemetry-grid'>
                        <div className='tel-box name-box'>{mName}</div>
                        <div className='tel-box arm-box'>
                            {arm ? 'ARM' : 'DISARM'}
                        </div>
                        <MsgBox imei={imei} showMsgs={showMsgsAct} startMsgs={startMsgs}/>
                        <ModeBox type={uavType} mode={uavMode} isOnline={isOnline}/>
                        <div className='tel-box sat-box'><img className='sat-box-icon' src="/image/modem/sat.svg"/><div>{currentTelemetry?.sputniksCount ?? -1}</div></div>
                        <BatteryBox batterys={currentTelemetry?.batteryRemaining}/>
                        <div className='tel-box menu-box' >
                            <img className='menu-box-sep' onClick={toggleShowMenu} src="/image/modem/settings.svg"/>
                            <UserSettings login = {login} isAdmin = {isAdmin} missionPlannerUrl={missionPlannerUrl} isAstra = {isAstra}/>
                        </div>
                    </div>}
                </div>
        </header>
    )
}

export default ConsoleNavMenu;